document.addEventListener('sh:cart:change', e => {
    fetch(window.location.origin)
        .then((response) => response.text())
        .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['#discount-progress-bars'];
            for (const selector of selectors) {
                const targetElement = document.querySelector(selector);
                const sourceElement = html.querySelector(selector);
                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }
            }
        })
        .catch((e) => {
            console.error(e);
        });
})